import { BoundedContent, Box } from '@vp/swan';

export function InternalErrorWrapper({
    children,
}: {
    useImg?: boolean;
    children: React.ReactNode;
}) {
    return (
        <BoundedContent>
            <Box marginTop={10} marginBottom={'7'} textAlign="center">
                <Box marginTop={8}>
                    <img
                        alt="ghost"
                        src="https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/expert_services/Brief/Ghost.png"
                        width={128}
                        height={128}
                    />
                </Box>
                <Box marginTop={8}>{children}</Box>
            </Box>
        </BoundedContent>
    );
}
